<dx-data-grid #grid [dataSource]="dataSource" [showBorders]="true" [focusedRowEnabled]="false"
  [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
  [columnResizingMode]="columnResizingMode" [showColumnLines]="true" [showRowLines]="true"
  [rowAlternationEnabled]="true">
  <dxo-paging [pageSize]="20">
  </dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 50]">
  </dxo-pager>

  <dxo-export [enabled]="true"></dxo-export>

  <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false" [useIcons]="true">
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
  </dxo-editing>

  <dxo-filter-row [visible]="false"></dxo-filter-row>

  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

  <dxi-column dataField="progr" caption="Progr">
  </dxi-column>
  <dxi-column dataField="idArticolo" caption="Articolo">
    <dxo-lookup [dataSource]="listArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
  </dxi-column>
  @if (gestMatricole) {
    <dxi-column
      dataField="idArticoloMatricola"
      caption="Matricola">
      <dxo-lookup [dataSource]="listArticoliMatricola" valueExpr="id" displayExpr="matricola" ></dxo-lookup>
    </dxi-column>
  }
  <dxi-column
    dataField="data"
    format="dd/MM/yyyy"
    dataType="date"
    [sortIndex]="1"
    sortOrder="desc">
  </dxi-column>
  <dxi-column
    dataField="qta">
  </dxi-column>
  <dxi-column
    dataField="cambio"
    dataType="boolean"
    [visible]="true">
  </dxi-column>
  <dxi-column
    caption="Restituito precedente"
    name="cambioString"
    [formItem]="{ visible: false }"
    [allowFiltering]="false"
    [allowSorting]="false" cellTemplate="restituitoPrecedenteTemplate"
    [visible]="false">
  </dxi-column>
  <div *dxTemplate="let d of 'restituitoPrecedenteTemplate'">
    @if (d.data.cambio) {
      <span>Sì</span>
    }
    @if (!d.data.cambio) {
      <span>No</span>
    }
  </div>



</dx-data-grid>